import React, { useState, useEffect } from "react";
import styles from './dwn-style.module.css';
import { useNavigate, useLocation } from 'react-router-dom';


const FitSocialSupportOnboard = () => {

const navigate = useNavigate();
const location = useLocation()
const [pid] = useState(location?.state?.pid )
const [supporting] = useState(location.state.supporting)
const[access, setAccess] = useState(-1)

 const [onBoardData, setOnBoardData] = useState({
    username:"",
    password:""
  })

  const [demographicData, setDemographicData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    phoneNumber: "",
    supportGender: "",                      // support's gender
    supportGenderIdentity: "",             // support's gender identity
    otherGenderIdentity: "",              // Description for custom gender identity
    supportDOB: "",                        // support's date of birth
    highestGradeFinished: "",             // Highest grade completed by the support
    worksOutside: "",                     // Whether the support works outside
    occupation: "",                       // support's occupation
    computerAccess: "",                   // Access to a computer
    internetOnComputer: "",               // Internet access on a computer
    cellPhoneAccess: "",                  // Access to a cell phone
    internetOnPhone: "",                  // Internet access on a phone
    nutritionProgram: "",                 // Participation in a nutrition program
    programEnrolled: "",                  // Specific nutrition program enrolled
    relationshipToChild: "",              // Relationship to the child
    otherRelationshipDescription: "",     // Description for "other" relationship
    relationshipStatus: "",               // support's relationship status
    incomeCategory: "",                   // support's income category
    workHours: "",                        // Weekly work hours
    employmentMonths: "",                 // Months employed in the last year
    
    
  
    hispanicLatinoOrigin: {               // support's Hispanic/Latino origin
      no: false,
      mexican: false,
      puertoRican: false,
      cuban: false,
      anotherHispanic: false,
      otherHispanicDescription: "",      // Description for "another Hispanic origin"
    },
  
    race: {                               // support's race
      white: false,
      blackOrAfricanAmerican: false,
      americanIndianOrAlaskaNative: false,
      asianIndian: false,
      chinese: false,
      filipino: false,
      japanese: false,
      korean: false,
      vietnamese: false,
      otherAsian: false,
      nativeHawaiian: false,
      guamanianOrChamorro: false,
      samoan: false,
      otherPacificIslander: false,
    },


    moneyIssues: {
      foodOrTransport: false,
      housing: false,
      highHousingCosts: false,
      largeDebt: false,
      lateOnBill: false,
      vicesSpending: false,
      borrowedMoney: false,
      foodBank: false,
      moneyArguments: false,
    },
    financialAid: {
      foodStamps: false,
      socialSecurity: false,
      supplementalIncome: false,
      temporaryAssistance: false,
      aidForDisabledChildren: false,
      otherAid: false,
    },
    otherAidDetails: "",
  });
  



 useEffect(() => {
  if (pid == null) {
    navigate('/');
  } else {
    const body = { "username": pid, "scope": "participant" };
    let connectionString = "https://app.digitalwellnessnurse.com"; //https://app.digitalwellnessnurse.com  http://localhost:2001

    fetch(`${connectionString}/api/portal/verify`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: "include",
      body: JSON.stringify(body),
    })
      .then((response) => {
        setAccess(response.status);
        return response.json();
      })
      .then((json) => {
        if (json.access !== 200) {
          navigate('/');

        } 
      })
      .catch((error) => {
        console.error("Error verifying access:", error);
      });
  }
   }, [pid, navigate]); 


 const generateUsername = async (supportFirstName, parentLastName, parentUsername) => {
    const maxLastNameLength = 5;
  
    // Extract family index from parent's username
    const match = parentUsername.match(/(\d+)d\d*$/); // Extract the Family ID (last digit group)
    const familyIndex = match[1];
    // Generate base username
    const supportBase =
      supportFirstName.charAt(0).toLowerCase() +
      parentLastName.substring(0, Math.min(maxLastNameLength, parentLastName.length)).toLowerCase();
  
    // Append family index and role suffix
    const supportUsername = `${supportBase}${familyIndex}d3`;
  
    return supportUsername;
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setOnBoardData({
      ...onBoardData,
      [name]: value,
    });
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setDemographicData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (event, category) => {
    const { name, checked } = event.target;
    setDemographicData((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [name]: checked,
      },
    }));
  };

  const handleTextChange = (event, category) => {
    const { name, value } = event.target;
    setDemographicData((prevState) => ({
      ...prevState,
      [category]: {
        ...prevState[category],
        [name]: value,
      },
    }));
  };



  const validateFirstAndLastName = () => {
    const { firstName, lastName } = demographicData;
  
    // Check if either field is empty
    if (!firstName.trim() || !lastName.trim()) {
      let missingFields = [];
      if (!firstName.trim()) missingFields.push("First Name");
      if (!lastName.trim()) missingFields.push("Last Name");
  
      alert(`Please fill in the following field(s): ${missingFields.join(", ")}`);
      return false; // Validation failed
    }
  
    return true; // Validation successful
  };
  

  const handleNext = async () => {
     if (validateFirstAndLastName()) {
        if (onBoardData.password.length < 9) {
        alert('Password must be at least 9 characters long.');
        return;
        } else {
        // Generate usernames
        const username = await generateUsername(demographicData.firstName, supporting.parent.parentLastName, supporting.parent.parentUsername);
    
        // Update onBoardData
        const updatedOnBoardData = {
            ...onBoardData,
            username
        };
    
        setOnBoardData(updatedOnBoardData);
        // Navigate with the updated data
        navigate('/FitSupportWelcome', { state: { pid:pid, onBoardData: updatedOnBoardData, demographicData: demographicData, supporting:supporting} });
        }
    }/*else {
        // Show an alert with the missing fields
        const missingFieldsMessage = Object.values(emptyFields).join('\n');
        alert(`Please fill in the following fields:\n${missingFieldsMessage}`);
      }*/
  };
  


  return (
   <div className={styles.signupForm}>
    <form onSubmit={handleNext}>
      <h2>Social Support Information</h2>

      <div className={styles.form2Group}>
        <label>
            First Name:
            <input
            type="text"
            name="firstName"
            value={demographicData.firstName}
            onChange={handleChange}
            placeholder="Enter your first name"
            required
            />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>
            Last Name:
            <input
            type="text"
            name="lastName"
            value={demographicData.lastName}
            onChange={handleChange}
            placeholder="Enter your last name"
            required
            />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>Password:
          <input type="text" 
          name="password" 
          value={onBoardData.password} 
          onChange={handlePasswordChange} 
          required />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>
            Address:
            <input
            type="text"
            name="address"
            value={demographicData.address}
            onChange={handleChange}
            placeholder="Enter your address"
            required
            />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>
            City:
            <input
            type="text"
            name="city"
            value={demographicData.city}
            onChange={handleChange}
            placeholder="Enter your city"
            required
            />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>
            State:
            <input
            type="text"
            name="state"
            value={demographicData.state}
            onChange={handleChange}
            placeholder="Enter your state"
            required
            />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>
            Zip Code:
            <input
            type="text"
            name="zipCode"
            value={demographicData.zipCode}
            onChange={handleChange}
            placeholder="Enter your zip code"
            required
            />
        </label>
        </div>

        <div className={styles.form2Group}>
        <label>
            Phone Number:
            <input
            type="tel"
            name="phoneNumber"
            value={demographicData.phoneNumber}
            onChange={handleChange}
            placeholder="Enter your phone number"
            required
            />
        </label>
        </div>

      <div className={styles.form2Group}>
        <label>What was your sex at birth:
          <select name="supportGender" value={demographicData.supportGender} onChange={handleChange} required>
            <option value="">Select</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Prefer not say/unknown">Prefer not say/unknown</option>
          </select>
        </label>
      </div>
      <div className={styles.form2Group}>
      <label>
        What is your gender identity:
        <select
          name="supportGenderIdentity"
          value={demographicData.supportGenderIdentity}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Man/boy">Man/boy</option>
          <option value="Woman/girl">Woman/girl</option>
          <option value="Non-Binary">Non-Binary</option>
          <option value="Transgender man/trans man/female-to-male (FTM)">
            Transgender man/trans man/female-to-male (FTM)
          </option>
          <option value="Transgender woman/trans woman/male-to-female (MTF)">
            Transgender woman/trans woman/male-to-female (MTF)
          </option>
          <option value="Genderqueer/gender nonconforming neither exclusively male nor female">
            Genderqueer/gender nonconforming neither exclusively male nor female
          </option>
          <option value="Additional gender category (or other)">
            Additional gender category (or other); please specify:
          </option>
          <option value="Decline to answer">Decline to answer</option>
        </select>
      </label>

      {demographicData.supportGenderIdentity === 'Additional gender category (or other)' && (
        <div>
          <label>
            If "Other", please describe your gender identity:
            <input
              type="text"
              name="otherGenderIdentity"
              value={demographicData.otherGenderIdentity}
              onChange={handleChange}
              placeholder="Please specify"
              required
            />
          </label>
        </div>
      )}
      </div>
      <div className={styles.form2Group}>
        <label>Are you Hispanic, Latino/a, or Spanish origin?</label>
        <div className={styles.checkboxGroup}>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="no"
              checked={demographicData.hispanicLatinoOrigin.no}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            No, not of Hispanic, Latino/a, or Spanish origin
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="mexican"
              checked={demographicData.hispanicLatinoOrigin.mexican}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Mexican, Mexican American, Chicano/a
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="puertoRican"
              checked={demographicData.hispanicLatinoOrigin.puertoRican}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Puerto Rican
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="cuban"
              checked={demographicData.hispanicLatinoOrigin.cuban}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Cuban
          </label>
          <label className={styles.checkboxItem}>
            <input
              type="checkbox"
              name="anotherHispanic"
              checked={demographicData.hispanicLatinoOrigin.anotherHispanic}
              onChange={(e) => handleCheckboxChange(e, 'hispanicLatinoOrigin')}
            />
            Another Hispanic, Latino, or Spanish origin
          </label>
        </div>
        {demographicData.hispanicLatinoOrigin.anotherHispanic && (
          <div className={styles.form2Group}>
            <label className="specifyLabel">Please specify:</label>
            <input
              type="text"
              name="otherHispanicDescription"
              value={demographicData.hispanicLatinoOrigin.otherHispanicDescription}
              onChange={(e) => handleTextChange(e, 'hispanicLatinoOrigin')}
              placeholder="Specify origin"
              className="textInput"
            />
          </div>
        )}
      </div>

      <div className={styles.form2Group}>
        <label>What is your race?</label>
        <div className={styles.checkboxGroup}>
          {[
            { name: 'white', label: 'White' },
            { name: 'blackOrAfricanAmerican', label: 'Black or African American' },
            { name: 'americanIndianOrAlaskaNative', label: 'American Indian or Alaska Native' },
            { name: 'asianIndian', label: 'Asian Indian' },
            { name: 'chinese', label: 'Chinese' },
            { name: 'filipino', label: 'Filipino' },
            { name: 'japanese', label: 'Japanese' },
            { name: 'korean', label: 'Korean' },
            { name: 'vietnamese', label: 'Vietnamese' },
            { name: 'otherAsian', label: 'Other Asian' },
            { name: 'nativeHawaiian', label: 'Native Hawaiian' },
            { name: 'guamanianOrChamorro', label: 'Guamanian or Chamorro' },
            { name: 'samoan', label: 'Samoan' },
            { name: 'otherPacificIslander', label: 'Other Pacific Islander' },
          ].map((raceOption) => (
            <label key={raceOption.name} className={styles.checkboxItem}>
              <input
                type="checkbox"
                name={raceOption.name}
                checked={demographicData.race[raceOption.name]}
                onChange={(e) => handleCheckboxChange(e, 'race')}
              />
              {raceOption.label}
            </label>
          ))}
        </div>
      </div>
      <div className={styles.form2Group}>
        <label>Date of Birth:
          <input type="date" name="supportDOB" value={demographicData.supportDOB} onChange={handleChange} required />
        </label>
      </div>
      {/* Highest Grade Finished */}
      <div className={styles.form2Group}>
        <label>What is the highest grade in school you finished?</label>
        <select
          name="highestGradeFinished"
          value={demographicData.highestGradeFinished}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Did not finish elementary school">Did not finish elementary school</option>
          <option value="Finished middle school (8th grade)">Finished middle school (8th grade)</option>
          <option value="Finished some high school">Finished some high school</option>
          <option value="High School Graduate or G.E.D.">High School Graduate or G.E.D.</option>
          <option value="Vocational or training school after high school">
            Vocational or training school after high school
          </option>
          <option value="Some college or Associate Degree">Some college or Associate Degree</option>
          <option value="College graduate or Baccalaureate Degree">
            College graduate or Baccalaureate Degree
          </option>
          <option value="Masters (MS) or Doctoral Degree (PhD, MD, JD, etc.)">
            Masters (MS) or Doctoral Degree (PhD, MD, JD, etc.)
          </option>
        </select>
      </div>


      {/* Occupation */}
      <div className={styles.form2Group}>
        <label>What is your occupation and job title?</label>
        <input
          type="text"
          name="occupation"
          value={demographicData.occupation}
          onChange={handleChange}
          placeholder="Enter your occupation and job title"
          required
        />
      </div>

      {/* Computer Access */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to a computer at home?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="computerAccess"
            value="Yes"
            checked={demographicData.computerAccess === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="computerAccess"
            value="No"
            checked={demographicData.computerAccess === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Internet on Computer */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to the internet on this home computer?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnComputer"
            value="Yes"
            checked={demographicData.internetOnComputer === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnComputer"
            value="No"
            checked={demographicData.internetOnComputer === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Cell Phone Access */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to a cell phone?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="cellPhoneAccess"
            value="Yes"
            checked={demographicData.cellPhoneAccess === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="cellPhoneAccess"
            value="No"
            checked={demographicData.cellPhoneAccess === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

      {/* Internet on Cell Phone */}
      <div className={styles.form2Group}>
        <label>Do you have daily access to the internet on this cell phone?</label>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnPhone"
            value="Yes"
            checked={demographicData.internetOnPhone === "Yes"}
            onChange={handleChange}
          />
          Yes
        </div>
        <div className={styles.form2Group}>
          <input
            type="radio"
            name="internetOnPhone"
            value="No"
            checked={demographicData.internetOnPhone === "No"}
            onChange={handleChange}
          />
          No
        </div>
      </div>

{/* Nutrition Program */}
<div className={styles.form2Group}>
  <label>Are you a part of a supplemental nutrition program (like SNAP)?</label>
  <div className={styles.form2Group}>
    <input
      type="radio"
      name="nutritionProgram"
      value="Yes"
      checked={demographicData.nutritionProgram === "Yes"}
      onChange={handleChange}
    />
    Yes
  </div>
  <div className={styles.form2Group}>
    <input
      type="radio"
      name="nutritionProgram"
      value="No"
      checked={demographicData.nutritionProgram === "No"}
      onChange={handleChange}
    />
    No
  </div>
</div>

{/* Program Enrolled */}
{demographicData.nutritionProgram === "Yes" && (
  <div className={styles.form2Group}>
    <label>What program are you currently enrolled in?</label>
    <input
      type="text"
      name="programEnrolled"
      value={demographicData.programEnrolled}
      onChange={handleChange}
      placeholder="Enter program name"
    />
  </div>
)}

    {/* Relationship to Child */}
    <div className={styles.form2Group}>
  <label>What is your relationship to this child?</label>
  <select
    name="relationshipToChild"
    value={demographicData.relationshipToChild}
    onChange={handleChange}
    required
  >
    <option value="">Select</option>
    <option value="Biological support">Biological support</option>
    <option value="Step-support">Step-support</option>
    <option value="Adoptive support (non-family)">Adoptive support (non-family)</option>
    <option value="Guardian (non-family)">Guardian (non-family)</option>
    <option value="Foster support">Foster support</option>
    <option value="Adoptive support (family)">Adoptive support (family)</option>
    <option value="Guardian (family)">Guardian (family)</option>
    <option value="Other">Other</option>
  </select>
</div>

{demographicData.relationshipToChild === "Other" && (
  <div className={styles.form2Group}>
    <label>You selected "Other" in response to the previous question. Please describe:</label>
    <input
      type="text"
      name="otherRelationshipDescription"
      value={demographicData.otherRelationshipDescription}
      onChange={handleChange}
      placeholder="Describe your relationship"
      className={styles.textInput}
    />
  </div>
)}
      {/* Relationship Status */}
      <div className={styles.form2Group}>
        <label>What is your current relationship status?</label>
        <select
          name="relationshipStatus"
          value={demographicData.relationshipStatus}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Single or casually dating">Single or casually dating</option>
          <option value="Living in a marriage-like relationship">Living in a marriage-like relationship</option>
          <option value="Separated">Separated</option>
          <option value="Widowed">Widowed</option>
          <option value="In a committed relationship or engaged">
            In a committed relationship or engaged
          </option>
          <option value="Presently married">Presently married</option>
          <option value="Divorced">Divorced</option>
        </select>
      </div>

      {/* Income */}
      <div className={styles.form2Group}>
        <label>Which of these categories best describes your income?</label>
        <select
          name="incomeCategory"
          value={demographicData.incomeCategory}
          onChange={handleChange}
          required
        >
          <option value="">Select</option>
          <option value="Less than $5,000">Less than $5,000</option>
          <option value="$5,000 through $11,999">$5,000 through $11,999</option>
          <option value="$12,000 through $15,999">$12,000 through $15,999</option>
          <option value="$16,000 through $24,999">$16,000 through $24,999</option>
          <option value="$25,000 through $34,999">$25,000 through $34,999</option>
          <option value="$35,000 through $49,999">$35,000 through $49,999</option>
          <option value="$50,000 through $74,999">$50,000 through $74,999</option>
          <option value="$75,000 through $99,999">$75,000 through $99,999</option>
          <option value="$100,000 or greater">$100,000 or greater</option>
          <option value="Don't know">Don't know</option>
        </select>
      </div>


      {/* Work Hours */}
      <div className={styles.form2Group}>
        <label>How many hours do you work per week on average?</label>
        <input
          type="numeric"
          name="workHours"
          value={demographicData.workHours}
          onChange={handleChange}
          placeholder="Enter hours per week"
          required
        />
      </div>

      {/* Employment Months */}
      <div className={styles.form2Group}>
        <label>How many months were you employed in the last year?</label>
        <input
          type="numeric"
          name="employmentMonths"
          value={demographicData.employmentMonths}
          onChange={handleChange}
          placeholder="Enter months"
          required
        />
      </div>

  <div className={styles.form2Group}>
  <label>Do you work outside the home?</label>
  <input
    type="radio"
    name="worksOutside"
    value="Yes"
    checked={demographicData.worksOutside === "Yes"}
    onChange={handleChange}
  /> Yes
  <input
    type="radio"
    name="worksOutside"
    value="No"
    checked={demographicData.worksOutside === "No"}
    onChange={handleChange}
  /> No
</div>

      {/* Money Issues Section */}
      <div className={styles.checkboxGroup}>
        <label className={styles.checkboxGroupLabel}>In the past year, have you:</label>
        {[
          { name: "foodOrTransport", label: "Run out of money for food or transportation" },
          { name: "housing", label: "Run out of money for housing" },
          {
            name: "highHousingCosts",
            label: "Spent half or more of your income on housing and utilities (electricity, gas, cable, water)",
          },
          {
            name: "largeDebt",
            label: "Not counting a home or car loan, owed people more than what you make in two months",
          },
          { name: "lateOnBill", label: "Been 120 days or more behind on a bill" },
          { name: "vicesSpending", label: "Spent money that was needed for bills on alcohol, drugs, or gambling" },
          {
            name: "borrowedMoney",
            label: "Had to borrow money from another family member or close friend for food, rent, or utilities",
          },
          { name: "foodBank", label: "Had to use food bank, soup kitchen or emergency shelter" },
          { name: "moneyArguments", label: "Argued regularly with other people in your family or household about money" },
        ].map((item) => (
          <div className={styles.checkboxItem} key={item.name}>
            <input
              type="checkbox"
              id={item.name}
              name={item.name}
              onChange={(e) => handleCheckboxChange(e, "moneyIssues")}
              checked={demographicData.moneyIssues[item.name]}
            />
            <label htmlFor={item.name}>{item.label}</label>
          </div>
        ))}
      </div>

      {/* Financial Aid Section */}
      <div className={styles.checkboxGroup}>
        <label className={styles.checkboxGroupLabel}>
          Do you or other adults living in the home receive any of the following kinds of financial aid?
        </label>
        {[
          { name: "foodStamps", label: "Food stamps/WIC" },
          { name: "socialSecurity", label: "Social Security Disability (SSD)" },
          { name: "supplementalIncome", label: "Supplemental Security Income (SSI)" },
          { name: "temporaryAssistance", label: "Temporary Assistance for Needy Families (TANF)" },
          { name: "aidForDisabledChildren", label: "Aid to Families with Disabled Children" },
          { name: "otherAid", label: "Other" },
        ].map((item) => (
          <div className={styles.checkboxItem} key={item.name}>
            <input
              type="checkbox"
              id={item.name}
              name={item.name}
              onChange={(e) => handleCheckboxChange(e, "financialAid")}
              checked={demographicData.financialAid[item.name]}
            />
            <label htmlFor={item.name}>{item.label}</label>
          </div>
        ))}
      </div>
      {demographicData.financialAid.otherAid && (
        <div className={styles.formGroup}>
          <label htmlFor="otherAidDetails" className={styles.label}>
            Specify "Other" kind of financial aid:
          </label>
          <input
            type="text"
            id="otherAidDetails"
            name="otherAidDetails"
            value={demographicData.otherAidDetails}
            onChange={handleChange}
            placeholder="Enter details"
            className={styles.textInput}
          />
        </div>
      )}

      <button className={styles.generateBtn} type="button" onClick={handleNext}>Submit</button>
      
    </form>
    </div>
  );
};

export default FitSocialSupportOnboard;

